import { debounce } from "lodash-es";
import React, {
  FC,
  ReactElement,
  useCallback,
  useEffect,
  useState,
} from "react";

import TextEditor from "../../../components/TextEditor";
import {
  getPolicyFormProperty,
  setPolicyFormProperty,
} from "../../../slices/policies";
import { useDispatch, useSelector } from "../../../store";
import { Document } from "../../../utils/ppl";

type PPLEditorProps = {
  readonly: boolean;
  isCurrentTab: boolean;
};

export const PPLEditor: FC<PPLEditorProps> = ({
  readonly,
  isCurrentTab,
}): ReactElement => {
  const ppl = useSelector(getPolicyFormProperty("ppl", {})) as object;
  const [pplString, setPplString] = useState(Document.fromValue(ppl).toYAML());
  const dispatch = useDispatch();

  const delayedOnSave = useCallback(
    debounce((val) => {
      try {
        const newDoc = Document.fromYAML(val || "{}").toValue();
        dispatch(
          setPolicyFormProperty({
            path: "ppl",
            value: newDoc,
          }),
        );
      } catch {
        //do nothing these errors are just from interim formats when people are typing
      }
    }, 300),
    [dispatch, setPolicyFormProperty],
  );

  function handleChange(value: string | undefined): void {
    setPplString(value || "");
    delayedOnSave(value || "");
  }

  useEffect(() => {
    setPplString(Document.fromValue(ppl).toYAML());
  }, [isCurrentTab]);

  return (
    <TextEditor
      defaultLanguage="yaml"
      value={pplString}
      onChange={handleChange}
      options={{
        readOnly: readonly,
      }}
    />
  );
};
export default PPLEditor;
